import styled from 'styled-components';

const ScreenTitle = styled.h1`
  font-size: min(5.2vw, 40px);
  font-weight: 400;
  color: #1b3f92;
  padding-bottom: 1rem;
  text-align: center;
  max-width: 100%
`;
export default ScreenTitle;
